import { put, call } from 'redux-saga/effects';

import { get } from '../../../../services/api';
import { translateCommentEndpoint } from '../../../../services/endpoint';
import {
  translateParentSuccess,
  translateParentFailure,
  translateChildSuccess,
  translateChildFailure
} from '../../../actions/comments/translation/translationActions';

export function* translateParentSaga(action) {
  const {
    payload: { commentId }
  } = action;

  try {
    const res = yield call(get, translateCommentEndpoint(commentId));
    if (res && res.body) {
      yield put(
        translateParentSuccess({ commentId, translatedComment: res.body })
      );
    } else {
      yield put(translateParentFailure(commentId));
    }
  } catch (err) {
    yield put(translateParentFailure(commentId));
  }
}

export function* translateChildSaga(action) {
  const {
    payload: { commentId, rootId }
  } = action;

  try {
    // Endpoint just takes a commentId
    // regardless if it's a parent or child comment
    const res = yield call(get, translateCommentEndpoint(commentId));
    if (res && res.body) {
      yield put(
        translateChildSuccess({
          commentId,
          rootId,
          translatedComment: res.body
        })
      );
    } else {
      yield put(translateChildFailure({ commentId, rootId }));
    }
  } catch (err) {
    yield put(translateChildFailure({ commentId, rootId }));
  }
}
